<div class="ui-fluid">
  <!-- TODO Searching works on ID# name & employee number we should specify this to the user later  -->

  <label *ngIf="showLabels">{{ label }}</label>

  <div class="formgrid grid">
    <div class="field col-12">
      <span class="p-fluid">
        <p-autoComplete
          (completeMethod)="search($event)"
          (onClear)="clearSelect()"
          (onSelect)="handleSelect()"
          [(ngModel)]="selectedUsers"
          [dropdown]="true"
          [suggestions]="userResults"
          emptyMessage="No Users were found matching the search."
          [field]="createUserLabel"
          [placeholder]="placeHolderText"
          [multiple]="multipleUsers"
        >
          <ng-template let-result pTemplate="item">
            <!-- <img src="{{entry.user.id}}.png" style="width:32px;display:inline-block;margin:5px 0 2px 5px"/> -->
            <div>
              {{ result.userLabel }}
            </div>
          </ng-template>
        </p-autoComplete>
      </span>
      <small *ngIf="showHelp"
        >Search by name, number, ID, email, employee number.</small
      >
    </div>
  </div>
</div>
